import { useApiGetSchoolList } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/pelaksanaan/school'

const usePenilaianCountPs = ({ enabled = false }: { enabled: boolean }) => {
  const {
    data: { meta: counterKs } = {},
    isLoading: isLodingCountKs,
    isFetched: isFetchedKs,
  } = useApiGetSchoolList({ page: 1, pageSize: 1, role: 'KS' }, { enabled })

  const {
    data: { meta: counterGuru } = {},
    isLoading: isLodingCountGuru,
    isFetched: isFetchedGuru,
  } = useApiGetSchoolList({ page: 1, pageSize: 1, role: 'GURU' }, { enabled })

  return {
    isLoading: isLodingCountKs || isLodingCountGuru,
    isSuccess: isFetchedKs || isFetchedGuru,
    data: {
      finish:
        parseInt(`${counterKs?.counts?.allCompleted || 0}`, 10) +
        parseInt(`${counterGuru?.counts?.allCompleted || 0}`, 10),
      all:
        parseInt(`${counterKs?.counts?.all || 0}`, 10) +
        parseInt(`${counterGuru?.counts?.all || 0}`, 10),
    },
  }
}

export default usePenilaianCountPs
